var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2918 2.79174C9.2918 4.05526 8.26357 5.08349 7.00006 5.08349C5.73654 5.08349 4.70831 4.05526 4.70831 2.79174C4.70831 1.52823 5.73654 0.5 7.00006 0.5C8.26357 0.5 9.2918 1.52823 9.2918 2.79174ZM0.888672 10.6847V9.00562C0.888672 8.0329 1.7575 7.19514 3.00013 6.82031C2.63345 7.3138 2.4165 7.88164 2.4165 8.49634V10.6847H0.888672ZM3.68969 2.79126C3.68969 2.56514 3.71261 2.34462 3.7559 2.13124C3.5746 2.0686 3.3826 2.02734 3.18042 2.02734C2.19751 2.02734 1.39795 2.82691 1.39795 3.80981C1.39795 4.79271 2.19751 5.59228 3.18042 5.59228C3.71618 5.59228 4.19184 5.34986 4.51879 4.97453C4.00493 4.39089 3.68969 3.628 3.68969 2.79126ZM11.5829 8.49634C11.5829 7.88113 11.3665 7.3138 10.9993 6.82031C12.2419 7.19463 13.1112 8.03239 13.1107 9.00511V10.6842H11.5829V8.49634ZM12.602 3.80981C12.602 2.82691 11.8025 2.02734 10.8196 2.02734C10.6169 2.02734 10.4254 2.0686 10.2441 2.13124C10.2874 2.34462 10.3103 2.56565 10.3103 2.79126C10.3103 3.628 9.99506 4.39089 9.4812 4.97453C9.80816 5.34986 10.2838 5.59228 10.8196 5.59228C11.802 5.59228 12.602 4.79271 12.602 3.80981ZM3.43518 8.49864C3.43518 7.17809 5.03431 6.10352 7.00011 6.10352C8.96592 6.10352 10.565 7.17809 10.565 8.49864V10.687H3.43518V8.49864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBadge);
export default __webpack_public_path__ + "static/media/group-badge.882f3920209512bfd7818bee4649f0d8.svg";
export { ForwardRef as ReactComponent };